module.exports = __webpack_public_path__ + "img/image.bda06b17.jpg";